var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0178 12L16.6339 4.43872C17.122 3.88083 17.122 2.97631 16.6339 2.41842C16.1457 1.86053 15.3543 1.86053 14.8661 2.41842L7.36612 10.9898C6.87796 11.5477 6.87796 12.4523 7.36612 13.0102L14.8661 21.5816C15.3543 22.1395 16.1457 22.1395 16.6339 21.5816C17.122 21.0237 17.122 20.1192 16.6339 19.5613L10.0178 12Z",
    fill: "#0A7CC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.6004ea8a2098eddda3c14626b1a86d54.svg";
export { ForwardRef as ReactComponent };